import React from "react";
import "../assets/css/slider.css"; // Custom styling

const BrochureElysiumTower = () => {
    return (
        <div className="slider-container">
            {/* <iframe widdth="100%" height="100vh" src="/Elysium_Tower/Brochure/brochure.pdf" style={{ width: "100vw", height: "100vh" }} rel="noopener noreferrer" /> */}
            <embed
                src="https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Real_Walk_Files/Brochure/Elysium_Tower_brochure.pdf"
                type="application/pdf"
                width="100%"
                height="100%"
            />
            {/* <iframe
                src={`https://docs.google.com/gview?url=https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Real_Walk_Files/Brochure/Elysium_Tower_brochure.pdf`}
                style={{ width: "100vw", height: "100vh" }}
            /> */}
            <iframe
                src="https://drive.google.com/viewerng/viewer?embedded=true&url=https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Real_Walk_Files/Brochure/Elysium_Tower_brochure.pdf"
                style={{ width: "100vw", height: "100vh" }}
            />
        </div>
    )
}

export default BrochureElysiumTower;